// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-square {
    height: 47px;
    margin: 0;
    cursor: pointer;
    font-size: 16px;
    margin-top: 12px;
    margin-bottom: 12px;
    margin-left: auto;
    margin-right: auto;
    display: block;
}

.side-panel-icon {
    font-size: 21px;
    border-radius: 3px;
    padding: 3px;
    text-align:center;
    cursor: pointer;
    height: 48px;
    width: 48px;
}

.eject-button {
    font-size: 0 !important;
    padding: 16px;
    width: 70%;
    text-align:center;
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
}

.load-button {
    font-size: 0 !important;
    padding: 16px;
    width: 70%;
    text-align:center;
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
}

.load-button:hover, .load-button:focus, .reset-visited-area-button:focus, .eject-button:focus {
    border-color: #d9d9d9;
}

.revoke-panel-buttons {
    font-size: 16px;
    border-radius: 51px;
    padding: 3px;
    text-align:center;
    cursor: pointer;
    height: 48px;
    width: 48px;
}

.initial-div-input-field, .initial-div-input-field:focus, .initial-div-input-field:hover {
    font-size: 16px;
    border-radius: 51px;
    padding: 3px;
    text-align:center;
    cursor: pointer;
    height: 48px;
    width: 48px;
    background-color: #8e8888;
    color:#1b1b1b;
    border-color: #d9d9d9;
}

.message-input-field, .message-input-field:focus, .message-input-field:hover {
    font-size: 16px;
    padding: 3px;
    border-radius: 51px;
    cursor: pointer;
    height: 48px;
    width: 48px;
    background-color: #8e8888;
    color:#1b1b1b;
    border-color: #d9d9d9;
}

.revoke-panel-buttons:hover, .reset-visited-area-button:hover, .side-panel-icon:hover, .eject-button:hover {
    border-color: #d9d9d9;
    background-color: #353535 !important;
}

.revoke-panel-buttons:focus {
    border-color: #d9d9d9;
    background-color: #353535 !important;
}

.side-panel-icon:focus {
    border-color: #d9d9d9;
}

.side-panel-icon-text {
    font-size: 10px;
}

.side-panel-icon-open, .side-panel-icon-open:hover, .side-panel-icon-open:active {
    border-color: #d9d9d9;
    background-color: #d9d9d9 !important;
}

.currently-ongoing-preview, .currently-ongoing-preview:hover, .currently-ongoing-preview:active {
    border-color: #c2c1c1;
    background-color: #c2c1c1 !important;
}

.scheduled-preview, .scheduled-preview:hover, .scheduled-preview:active {
    border-color: #6d6a6a;
    background-color: #6d6a6a !important;
}

.preview-taken, .preview-taken:hover, .preview-taken:active {
    border-color: blue;
}

.side-panel-icon-closeable-handle {
    font-size: 20px;
    position: absolute;
    right: 3px;
    cursor: pointer;
}

.relative-position {
    position: relative;
}

.place-bottom {
    position: absolute;
    left: 0;
    bottom: 0;
}

.mode-style {
    position: absolute;
    left: 0;
    bottom: 70px;
    pointer-events: none;
}

.overflow-wrap-text {
    white-space: pre;
}

.settings-box-livemode {
    position: absolute;
    right: -1012px;
    bottom: 11px;
    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;
    z-index: 2147483640;
    border-radius: 3px;
    width: 1000px;
    background-color: #3a3a3a;
    color: white;
    text-align: left;
}

.selected-style, .selected-style:focus, .selected-style:hover {
    color: #1b1b1b !important;
}

.unselected-style, .unselected-style:focus, .unselected-style:hover {
    color: #d9d9d9 !important;
    background-color: #1b1b1b;
}

.custom-select-background-color .ant-select-selection__placeholder {
    color : white;
}

.ant-progress-inner-custom .ant-progress-inner {
    border-radius: 0 !important;
}

.ant-progress-inner-custom .ant-progress-bg {
    border-radius: 0 !important;
    height: 3px !important;
}

.align-center {
    text-align: center;
}

.sidepanel-background-color {
    background: #1b1b1b;
}

.main-background-color {
    background: #111111;
}

.card-background-color {
    background: #3a3a3a;
}

.card-color {
    color: #3a3a3a;
}

.loading-message-livemode {
    position: absolute;
    left: 37.5%;
    bottom: 3.5%;
    border: 1px solid #d9d9d9;
    padding: 7px;
    border-radius: 15px;
    width: 300px;
    text-align: center;
}

.settings-heading {
    text-align: center;
    margin-top: 10px;
}

.settings-subheading {
    text-align: center;
    margin-top: 4px;
}

.select-slot-component > div > span { 
    font-size: 20px;
    color: white;
    margin-top: -10px;
}

.custom-select-background-color .ant-select-selection {
    background-color: #3a3a3a;
}

.zoom-controls-button-live-mode {
    margin-bottom: 3px;
    height: 50px;
    width: 50px;
    text-align: center;
    color: var(--theme-text-color);
}

.plus-button-live-mode {
    margin-bottom: 0;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    transition: none
}

.minus-button-live-mode {
    margin-top: 0;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}

.zoom-level-button-live-mode {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0 !important;
    height: 48px;
    line-height: 48px !important;
    padding: 0;
    font-weight: bold;
    cursor: default !important;
    border: 1px solid #d9d9d9;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    display: inline-block;
    vertical-align: middle;
    background-color: #fff;
}

.zoom-controls-icon {
    font-size: 20px;
}

.custom-zero-margin-divider .ant-divider-horizontal {
    margin: 0 !important;
}

.custom-top-bottom-margin-divider {
    margin-top: 5px;
    margin-bottom: 7px;
}

.custom-left-right-padding-settings {
    padding: 0 8px 0 8px;
}

.settings-close-icon-div {
    cursor: pointer;
    font-size: 20px;
    right: -8px;
    top: -8px;
    border: 1px solid white;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    background: #3a3a3a;
}

.settings-close-icon {
    font-size: 15px;
    top: -3px;
    right: 5px;
    position: absolute;
}

.blur {
    width:100%;
    height:100%;
    background-size:cover;
    pointer-events: none;
    -moz-filter: blur(4px);
    -ms-filter: blur(4px);
    -o-filter: blur(4px);
    filter: blur(4px);
}

.initial-options-div {
    position: absolute;
    left: 20%;
    top: 10%;
    font-size: 21px;
    padding: 3px;
    text-align:center;
    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;
    width: 60%;
    height: 80%;
    display : flex;
    align-items : center;
    background: #232323;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}

.livemode-focus-control-button-text {
    font-size: 8px;
    text-align: center;
}

.logo-live-mode {
    height: 80px;
    margin: 32px;
    background: #d9d9d9;
    border-radius: 24px;
    padding: 8px;
}

.live-mode-initial-message {
    margin-bottom: 16px;
    font-family: arial;
    font-size: 24px;
    color: #d9d9d9;
}

.initial-div-error-message {
    font-size: 16px;
    color: #d9d9d9 !important;
    align-self: center;
    padding-top: 8px;
    padding-left: 24px;
}

.pointer-events-none {
    pointer-events: none;
}

.chat-box-livemode {
    position: absolute;
    right: -762px;
    top: 27%;
    box-shadow: 0 0 7px 0 rgb(0 0 0 / 30%) !important;
    z-index: 2147483640;
    border-radius: 3px;
    width: 750px;
    background-color: #3a3a3a;
    color: white;
    text-align: left;
}

.messages-div {
    overflow: auto;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
}

.messages-div::-webkit-scrollbar {
	display: none;
}

.selected-slot-style, .selected-slot-style:hover, .selected-slot-style:active {
	text-decoration: underline !important;
	background-color: white !important;
}

.max-height-available {
	height: 100vh;
}

`, "",{"version":3,"sources":["webpack://./src/asset/style/livemode/livemode.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gDAAgD;IAChD,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,wCAAwC;IACxC;AACJ;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;IACjB,0BAA0B;IAC1B,yBAAyB;IACzB,wCAAwC;IACxC,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gDAAgD;IAChD,UAAU;IACV,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,iDAAiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qCAAqC;CACrC,kCAAkC;AACnC;;AAEA;CACC,aAAa;AACd","sourcesContent":[".logo-square {\n    height: 47px;\n    margin: 0;\n    cursor: pointer;\n    font-size: 16px;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n}\n\n.side-panel-icon {\n    font-size: 21px;\n    border-radius: 3px;\n    padding: 3px;\n    text-align:center;\n    cursor: pointer;\n    height: 48px;\n    width: 48px;\n}\n\n.eject-button {\n    font-size: 0 !important;\n    padding: 16px;\n    width: 70%;\n    text-align:center;\n    cursor: pointer;\n    border-radius: 4px;\n    margin: 4px;\n}\n\n.load-button {\n    font-size: 0 !important;\n    padding: 16px;\n    width: 70%;\n    text-align:center;\n    cursor: pointer;\n    border-radius: 4px;\n    margin: 4px;\n}\n\n.load-button:hover, .load-button:focus, .reset-visited-area-button:focus, .eject-button:focus {\n    border-color: #d9d9d9;\n}\n\n.revoke-panel-buttons {\n    font-size: 16px;\n    border-radius: 51px;\n    padding: 3px;\n    text-align:center;\n    cursor: pointer;\n    height: 48px;\n    width: 48px;\n}\n\n.initial-div-input-field, .initial-div-input-field:focus, .initial-div-input-field:hover {\n    font-size: 16px;\n    border-radius: 51px;\n    padding: 3px;\n    text-align:center;\n    cursor: pointer;\n    height: 48px;\n    width: 48px;\n    background-color: #8e8888;\n    color:#1b1b1b;\n    border-color: #d9d9d9;\n}\n\n.message-input-field, .message-input-field:focus, .message-input-field:hover {\n    font-size: 16px;\n    padding: 3px;\n    border-radius: 51px;\n    cursor: pointer;\n    height: 48px;\n    width: 48px;\n    background-color: #8e8888;\n    color:#1b1b1b;\n    border-color: #d9d9d9;\n}\n\n.revoke-panel-buttons:hover, .reset-visited-area-button:hover, .side-panel-icon:hover, .eject-button:hover {\n    border-color: #d9d9d9;\n    background-color: #353535 !important;\n}\n\n.revoke-panel-buttons:focus {\n    border-color: #d9d9d9;\n    background-color: #353535 !important;\n}\n\n.side-panel-icon:focus {\n    border-color: #d9d9d9;\n}\n\n.side-panel-icon-text {\n    font-size: 10px;\n}\n\n.side-panel-icon-open, .side-panel-icon-open:hover, .side-panel-icon-open:active {\n    border-color: #d9d9d9;\n    background-color: #d9d9d9 !important;\n}\n\n.currently-ongoing-preview, .currently-ongoing-preview:hover, .currently-ongoing-preview:active {\n    border-color: #c2c1c1;\n    background-color: #c2c1c1 !important;\n}\n\n.scheduled-preview, .scheduled-preview:hover, .scheduled-preview:active {\n    border-color: #6d6a6a;\n    background-color: #6d6a6a !important;\n}\n\n.preview-taken, .preview-taken:hover, .preview-taken:active {\n    border-color: blue;\n}\n\n.side-panel-icon-closeable-handle {\n    font-size: 20px;\n    position: absolute;\n    right: 3px;\n    cursor: pointer;\n}\n\n.relative-position {\n    position: relative;\n}\n\n.place-bottom {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\n.mode-style {\n    position: absolute;\n    left: 0;\n    bottom: 70px;\n    pointer-events: none;\n}\n\n.overflow-wrap-text {\n    white-space: pre;\n}\n\n.settings-box-livemode {\n    position: absolute;\n    right: -1012px;\n    bottom: 11px;\n    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;\n    z-index: 2147483640;\n    border-radius: 3px;\n    width: 1000px;\n    background-color: #3a3a3a;\n    color: white;\n    text-align: left;\n}\n\n.selected-style, .selected-style:focus, .selected-style:hover {\n    color: #1b1b1b !important;\n}\n\n.unselected-style, .unselected-style:focus, .unselected-style:hover {\n    color: #d9d9d9 !important;\n    background-color: #1b1b1b;\n}\n\n.custom-select-background-color .ant-select-selection__placeholder {\n    color : white;\n}\n\n.ant-progress-inner-custom .ant-progress-inner {\n    border-radius: 0 !important;\n}\n\n.ant-progress-inner-custom .ant-progress-bg {\n    border-radius: 0 !important;\n    height: 3px !important;\n}\n\n.align-center {\n    text-align: center;\n}\n\n.sidepanel-background-color {\n    background: #1b1b1b;\n}\n\n.main-background-color {\n    background: #111111;\n}\n\n.card-background-color {\n    background: #3a3a3a;\n}\n\n.card-color {\n    color: #3a3a3a;\n}\n\n.loading-message-livemode {\n    position: absolute;\n    left: 37.5%;\n    bottom: 3.5%;\n    border: 1px solid #d9d9d9;\n    padding: 7px;\n    border-radius: 15px;\n    width: 300px;\n    text-align: center;\n}\n\n.settings-heading {\n    text-align: center;\n    margin-top: 10px;\n}\n\n.settings-subheading {\n    text-align: center;\n    margin-top: 4px;\n}\n\n.select-slot-component > div > span { \n    font-size: 20px;\n    color: white;\n    margin-top: -10px;\n}\n\n.custom-select-background-color .ant-select-selection {\n    background-color: #3a3a3a;\n}\n\n.zoom-controls-button-live-mode {\n    margin-bottom: 3px;\n    height: 50px;\n    width: 50px;\n    text-align: center;\n    color: var(--theme-text-color);\n}\n\n.plus-button-live-mode {\n    margin-bottom: 0;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    transition: none\n}\n\n.minus-button-live-mode {\n    margin-top: 0;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.zoom-level-button-live-mode {\n    margin-top: 0;\n    margin-bottom: 0;\n    border-radius: 0 !important;\n    height: 48px;\n    line-height: 48px !important;\n    padding: 0;\n    font-weight: bold;\n    cursor: default !important;\n    border: 1px solid #d9d9d9;\n    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n    display: inline-block;\n    vertical-align: middle;\n    background-color: #fff;\n}\n\n.zoom-controls-icon {\n    font-size: 20px;\n}\n\n.custom-zero-margin-divider .ant-divider-horizontal {\n    margin: 0 !important;\n}\n\n.custom-top-bottom-margin-divider {\n    margin-top: 5px;\n    margin-bottom: 7px;\n}\n\n.custom-left-right-padding-settings {\n    padding: 0 8px 0 8px;\n}\n\n.settings-close-icon-div {\n    cursor: pointer;\n    font-size: 20px;\n    right: -8px;\n    top: -8px;\n    border: 1px solid white;\n    border-radius: 50%;\n    height: 20px;\n    width: 20px;\n    background: #3a3a3a;\n}\n\n.settings-close-icon {\n    font-size: 15px;\n    top: -3px;\n    right: 5px;\n    position: absolute;\n}\n\n.blur {\n    width:100%;\n    height:100%;\n    background-size:cover;\n    pointer-events: none;\n    -moz-filter: blur(4px);\n    -ms-filter: blur(4px);\n    -o-filter: blur(4px);\n    filter: blur(4px);\n}\n\n.initial-options-div {\n    position: absolute;\n    left: 20%;\n    top: 10%;\n    font-size: 21px;\n    padding: 3px;\n    text-align:center;\n    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;\n    width: 60%;\n    height: 80%;\n    display : flex;\n    align-items : center;\n    background: #232323;\n    border-top: 1px solid #d9d9d9;\n    border-bottom: 1px solid #d9d9d9;\n}\n\n.livemode-focus-control-button-text {\n    font-size: 8px;\n    text-align: center;\n}\n\n.logo-live-mode {\n    height: 80px;\n    margin: 32px;\n    background: #d9d9d9;\n    border-radius: 24px;\n    padding: 8px;\n}\n\n.live-mode-initial-message {\n    margin-bottom: 16px;\n    font-family: arial;\n    font-size: 24px;\n    color: #d9d9d9;\n}\n\n.initial-div-error-message {\n    font-size: 16px;\n    color: #d9d9d9 !important;\n    align-self: center;\n    padding-top: 8px;\n    padding-left: 24px;\n}\n\n.pointer-events-none {\n    pointer-events: none;\n}\n\n.chat-box-livemode {\n    position: absolute;\n    right: -762px;\n    top: 27%;\n    box-shadow: 0 0 7px 0 rgb(0 0 0 / 30%) !important;\n    z-index: 2147483640;\n    border-radius: 3px;\n    width: 750px;\n    background-color: #3a3a3a;\n    color: white;\n    text-align: left;\n}\n\n.messages-div {\n    overflow: auto;\n    overflow: -moz-scrollbars-none;\n    -ms-overflow-style: none;\n}\n\n.messages-div::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.selected-slot-style, .selected-slot-style:hover, .selected-slot-style:active {\n\ttext-decoration: underline !important;\n\tbackground-color: white !important;\n}\n\n.max-height-available {\n\theight: 100vh;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
